// ─────────────────────────────────────────────────────────────────────────────
// setupJump — the tiny wire format shared between GuideMeLauncher (encoder,
// used when it's mounted somewhere other than TournamentSetup and has to
// navigate cross-page) and TournamentSetup itself (decoder, read once on
// mount then scrubbed from the URL — same "read once, then scrub" idiom the
// old `?guide=` deep link used).
//
// `${tab-or-_}:${sectionId}` — `_` stands in for "no tab switch needed" (e.g.
// the Activated checkpoint, whose control lives in the anchor row above every
// tab, not inside one of them).
// ─────────────────────────────────────────────────────────────────────────────

export type JumpableItem = { id: string; tab?: string; sectionId?: string; externalHref?: string };

export function encodeSetupJump(item: JumpableItem): string {
  return `${item.tab ?? '_'}:${item.sectionId ?? ''}`;
}

export function decodeSetupJump(raw: string): { tab?: string; sectionId?: string } {
  const [tabPart, sectionId] = raw.split(':');
  return { tab: tabPart === '_' ? undefined : tabPart, sectionId };
}

// The Setup ("Run It" → Setup) return path landing back on the Organisation
// tab's identity card — used by any surface that deep-links OUT of Setup
// (e.g. OrgPanel's "Branding & veto" link) as both the `?from=` value it
// passes AND the fallback the destination page uses when a user lands there
// with no `from` (a direct link, no browser history to blindly navigate(-1)
// into). Single source of truth so the two ends of the trip can't drift.
export function orgSetupReturnPath(): string {
  return `/admin/setup?jump=${encodeSetupJump({ id: '', tab: 'org', sectionId: 'org-identity' })}`;
}
